// 写作详情
export default {
    path: "/writingDetail",
    name: "writingDetail",
    component: () => import("@/views/writingDetail/index.vue"),
    children: [
        {
            path: "/writingDetail/:type/:id",
            name: "writingDetail-type-id",
            component: () => import("@/views/writingDetail/index.vue"),
            meta: {
                isLogin: true,
            },
        }
    ]
}